import React from 'react'

import { Link } from 'react-router-dom'

import { Box, Grid } from '@material-ui/core'
import { SearchBox, TableClients, ClientDetail } from 'components/SelectClient'
import { routes } from 'routes'
import Footer from './components/Footer'

import DetachedInvoiceContext from 'contexts/DetachedInvoiceContext'

const DetachedInvoiceSelectCustomer = () => {
  const [name, setName] = React.useState('')
  const context = React.useContext(DetachedInvoiceContext)

  const handleSearch = name => setName(name)
  const handleCustumer = customer =>
    context.setData(data => ({ ...data, customer: customer }))

  return (
    <Box p={3}>
      <Box mb={4}>
        <SearchBox
          onSearch={handleSearch}
          data={{
            path: routes.invoices.steps.selectCustomer,
            destination: 'criação de fatura',
          }}
        />
        <Grid container>
          <Grid item sm={8} xs={12}>
            <Box mr={{ sm: 2 }} mb={{ xs: 2 }}>
              <TableClients
                name={name}
                onChangeCustomer={handleCustumer}
                initalCustomerId={context.data?.customer?.id}
              />
            </Box>
          </Grid>
          <Grid item sm={4} xs={12}>
            <ClientDetail customer={context.data?.customer} />
          </Grid>
        </Grid>
      </Box>

      <Footer
        prevButtonProps={{ component: Link, to: routes.invoices.all }}
        nextButtonProps={{
          component: Link,
          to: routes.invoices.steps.selectPlan,
          disabled: !context.data?.customer,
        }}
      />
    </Box>
  )
}

export default DetachedInvoiceSelectCustomer
